import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { configureAmplify } from './config/amplify';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './components/auth/LoginPage';
import AuthCallback from './components/auth/AuthCallback';
import MessagingPage from './pages/MessagingPage';
import AdminPage from './pages/AdminPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import './App.css';

// Configure Amplify on app initialization
configureAmplify();

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
              
              {/* Protected routes */}
              <Route 
                path="/messages" 
                element={
                  <ProtectedRoute>
                    <MessagingPage />
                  </ProtectedRoute>
                } 
              />
              
              {/* Admin-only routes */}
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute requiredRoles={['administrator']}>
                    <AdminPage />
                  </ProtectedRoute>
                } 
              />
              
              {/* Default redirect to messages */}
              <Route path="/" element={<Navigate to="/messages" replace />} />
              
              {/* Catch all - redirect to messages */}
              <Route path="*" element={<Navigate to="/messages" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
